module.exports = __webpack_public_path__ + "img/icons8-view-100.71800abe.png";